import React, { useState, useEffect, useRef, useCallback } from "react";
import { Modal, Form, Input, Button, Select, Spin } from "antd";
import { BASE_URL, callApi } from "../../api/apiCaller";
import { GreenNotify, RedNotify } from "../../helper/helper";
import { DeviceUUID } from "device-uuid";
import routes from "../../api/routes";
import axios from "axios";
import configureAppStore from "../../redux/store";
const { Option } = Select;

const CHUNK_SIZE = 5 * 1024 * 1024; 

let deviceId = localStorage.getItem("deviceId");
if (!deviceId) {
  let id = new DeviceUUID().get();
  localStorage.setItem("deviceId", id);
  deviceId = id;
}

const AddVideo = ({ visible, toggleModal, recordData }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [yogas, setYogas] = useState([]);
  const [imageError, setImageError] = useState("");
  const [thumbnailState, setThumbnailState] = useState(true); // Add state for thumbnail loading

  const token = configureAppStore.getState().userDataSlice.token;
  const imageInputRef = useRef(null);

  const dummyImage =
    "https://novathreadbucket.s3.amazonaws.com/nova-app-1685176470232-dummy.PNG";

  // Get token from the Redux store
  const uploadImageOnS3 = async (file) => {
    const myHeaders = new Headers();
    const formData = new FormData();
    formData.append("file", file);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };
    return await new Promise((resolve, reject) => {
      fetch(`${BASE_URL}uploadFile`, requestOptions)
        .then((response) => response.json())
        .then((result) => resolve(result?.url))
        .catch((error) => reject(error));
    });
  };

  useEffect(() => {
    if (visible) {
      if (recordData) {
        console.log("yoga", recordData);
        form.setFieldsValue({
          title: recordData?.title,
          content: recordData?.content?.trim(),
          yogaId: recordData?.yogaId?._id,
        });
        setImage(recordData?.thumbnail || dummyImage);
      } else {
        form.resetFields();
        setImage(null);
      }
    }
  }, [visible, recordData, form]);

  useEffect(() => {
    if (visible) {
      callApi(
        "GET",
        `${routes.getYogas}`,
        null,
        setIsLoading,
        (res) => {
          if (res.status === 200) {
            setYogas(res?.data?.faceYogas);
          } else {
            RedNotify("Error Occurred. Please try again later.");
          }
        },
        (error) => {
          RedNotify(
            "An error occurred during the API call. Please try again later.",
            error
          );
        }
      );
    }
  }, [visible]);

  const pickFile = (isImage) => {
    if (isImage) {
      imageInputRef.current.click();
    }
  };

  const handleFileChange = (event, isImage) => {
    console.log("event.target.files", event.target.files);
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];

      if (isImage) {
        const file = fileList[0];
        if (!validImageTypes.includes(file.type)) {
          setImageError("Please select a valid image file (jpg, jpeg, png).");
          return;
        }
        setImage(file);
        setImageError("");
      }
    }
  };

  const handleSave = () => {
    form.validateFields().then((values) => {
      const formdata = new FormData();
      formdata.append("yogaId", values.yogaId);
      formdata.append("title", values.title);
      formdata.append("content", values.content);
      if (typeof image == "string") formdata.append("thumbnail", image);
      else {
        RedNotify("Image is required");
        return;
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        timeout: 1500000,
      };

      const url = recordData
        ? `${routes.updateVideo}/${recordData._id}`
        : routes.createVideo;

      const method = recordData ? axios.patch : axios.post;
      setIsLoading(true);
      method(url, formdata, config)
        .then((response) => {
          GreenNotify(
            recordData
              ? "Video updated successfully"
              : "Video created successfully"
          );
          toggleModal();
        })
        .catch((error) => {
          console.error("Error Details:", error.toJSON());
          RedNotify("An error occurred. Please try again.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  };

  const getImagePreview = () => {
    if (image instanceof File) {
      return URL.createObjectURL(image);
    }
    return image || dummyImage;
  };

  return (
    <Modal
      title={recordData ? "Update Video" : "Create Video"}
      visible={visible}
      onCancel={toggleModal}
      footer={null}
    >
      {isLoading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100px",
          }}
        >
          <Spin />
        </div>
      ) : (
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item
            label="Yoga"
            name="yogaId"
            rules={[{ required: true, message: "Yoga is required" }]}
          >
            <Select>
              {yogas.map((yoga) => (
                <Option key={yoga._id} value={yoga._id}>
                  {yoga.title}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: "Title is required" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Content"
            name="content"
            rules={[{ required: true, message: "Content is required" }]}
          >
            <Input.TextArea />
          </Form.Item>

          <Form.Item label="Thumbnail">
            <Button
              type="dashed"
              onClick={() => pickFile(true)}
              style={{ width: "100%" }}
            >
              {image ? "Change Thumbnail" : "Upload Thumbnail"}
            </Button>
            <input
              ref={imageInputRef}
              type="file"
              style={{ display: "none" }}
              onChange={(event) => handleFileChange(event, true)}
              accept="image/*"
            />

            {imageError && <p style={{ color: "red" }}>{imageError}</p>}
            {image && (
              <>
                <img
                  src={getImagePreview()}
                  alt="Thumbnail"
                  style={{ width: "100%", height: "170px", marginTop: "10px" }}
                />
                <Button
                  onClick={async () => {
                    try {
                      setThumbnailState(false); // Set loading state to false before the upload
                      const url = await uploadImageOnS3(image);
                      setImage(url);
                      GreenNotify("Thumbnail updated successfully");
                      setThumbnailState(true); // Set loading state to true after upload completes
                    } catch (error) {
                      RedNotify("An error occurred. Please try again.");
                    }
                  }}
                  type="primary"
                  disabled={
                    !(image && typeof image !== "string" && thumbnailState)
                  }
                  style={{ width: "100%" }}
                >
                  {image && typeof image === "string"
                    ? "Image Saved"
                    : !thumbnailState
                    ? "Loading..."
                    : "Save Image"}
                </Button>
              </>
            )}
          </Form.Item>

          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={isLoading}
              style={{ width: "100%" }}
            >
              {recordData ? "Update" : "Create"} Video
            </Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default AddVideo;
